module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-picker"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Picker")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-picker', {
    attrs: {
      "columns": _vm.pickerColumns
    },
    on: {
      "change": _vm.handlePickerChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54047849!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/picker.vue
// module id = 247
// module chunks = 0